import { Component, OnInit, ViewChild,} from '@angular/core';
import { DateTime } from '../../dateTime';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ReportService } from '../services/report.service';
import { environment } from '../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}
@Component({
  selector: 'app-eventpl',
  templateUrl: './eventpl.component.html',
  styleUrls: ['./eventpl.component.scss']
})
export class EventplComponent implements OnInit {
  pageSize: number = 50;
  statementsTotalItems: any;
  statementsPageIndex: number;
  timeStatement: Date;
  dateStatement: Date;
  endDateStatement: Date;
  endTimeStatement: Date;
  endTime: any;
  userDetails: any;
  fromDate: any;
  toDate: any;
  sportPlList: any;
  profitloss: any;
  totalPL: any;
  commission: any;
  public Base_Url = environment['adminServerUrl'];
  sportPlListLength: any = 0;
  constructor(private reportService: ReportService,private toastr: ToastrService, private router: Router) { }
    @ViewChild('popoverRef') private _popoverRef: PopoverDirective;
    @ViewChild('startpopoverRef') private _startpopoverRef: PopoverDirective;
    @ViewChild('endpopoverRef') private _endpopoverRef: PopoverDirective;
    time: Date;
    date: Date;
    isDateVisible: boolean = true;
    isMeridian: boolean = false;
    dateTime = new Date();
    statementStartDate = new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000))
    statementEndDate = new Date()
    public token = localStorage.getItem('userAccessToken');
    reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ` + this.token
    });
  ngOnInit(): void {
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    this.statementStartDate.setHours(0, 0, 0, 0);
    this.statementEndDate.setHours(23, 59, 59)
  }
  dateSelectionDone() {
    this.isDateVisible = false;
  }
  updateDateStatement() {
    if (this.dateStatement) {
      this.statementStartDate = DateTime.getDateTime(this.dateStatement, this.timeStatement);
    }
    if (!this.timeStatement) {
      this.timeStatement = this.dateStatement;
    }
  }
  updateEndDateStatement() {
    if (this.endDateStatement) {
      this.statementEndDate = DateTime.getDateTime(this.endDateStatement, this.endTimeStatement);
    }
    if (!this.endTimeStatement) {
      this.endTimeStatement = this.endDateStatement;
    }
  }
  updateTimeStatement() {
    if (this.timeStatement) {
      this.statementStartDate = DateTime.getDateTime(this.dateStatement, this.timeStatement);
    }
  }
  updateEndTimeStatement() {
    if (this.endTime) {
      this.statementEndDate = DateTime.getDateTime(this.endDateStatement, this.endTimeStatement);
    }
  }
  updateDate() {

    if (this.date) {
      this.dateTime = DateTime.getDateTime(this.date, this.time);
    }
    if (!this.time) {
      this.time = this.date;
    }
  }

  updateTime() {
    if (this.time) {
      this.dateTime = DateTime.getDateTime(this.date, this.time);
    }
  }

  showDate() {
    this.isDateVisible = true;
  }

  showTime() {
    this.isDateVisible = false;
  }

  close() {
    this._popoverRef.hide();
  }

  now() {
    this.dateTime = DateTime.now(this.date);
    this.time = this.dateTime;
  }

  today() {
    this.statementStartDate = DateTime.now(this.date);
    this.statementEndDate = DateTime.now(this.date);
  }
  clear() {
    //https://valor-software.com/ngx-bootstrap/#/timepicker#dynamic
    //Check component DemoTimepickerDynamicComponent  -> clear() method;  void 0 evaluates to undefined
    this.time = void 0;
    this.date = void 0;
    this.dateTime = void 0;
  }
  pageChange(event?: any) {
    if (event) {
      this.statementsPageIndex = event
    }else{
      this.statementsPageIndex=1
    }
  }

  eventpl(from?: string){
    let data = {}
    if (from == 'filterBtnClick') {
      if (this.statementStartDate) {
        data["from_date"] = this.statementStartDate.toISOString()
        this.fromDate = this.statementStartDate.toISOString()
      }
      if (this.statementEndDate) {
        data["to_date"] = this.statementEndDate.toISOString()
        this.toDate = this.statementEndDate.toISOString()
      }
    }
    this.reportService.eventpl(data).subscribe((res)=> {
      if(res.status){
        this.sportPlList = res.data;
        this.sportPlListLength = (this.sportPlList).length
        for (let i = 0; i < this.sportPlList.length; i++) {
          this.sportPlList[i].totalPL = (this.sportPlList[i].total + this.sportPlList[i].commission)
        }
        this.profitloss = this.sportPlList.reduce(
          (a: number, b) => a + b.profitloss, 0);
        this.totalPL = this.sportPlList.reduce(
          (a: number, b) => a + b.totalPL, 0);
        this.commission = this.sportPlList.reduce(
          (a: number, b) => a + b.commission, 0)
      } else {
        this.toastr.error(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 5000
        });
        this.sportPlList = []
        this.sportPlListLength = 0
      }
      
      
    })
  }
  eventWisePl(data){
    let a = this.Base_Url.split('api/v1/');
    // console.log("194",a[0],"\n",id);
    // let b = 'http://192.168.0.9:4200/' + 'plMatchwise/' + data.sport_id + '/'+ data.sport_name + '/'+ this.fromDate + '/'+ this.toDate + '/' + data.type;
    this.router.navigate(['plMatchwise/' + data.sport_id + '/'+ data.sport_name + '/'+ this.fromDate + '/'+ this.toDate + '/' + data.type])
    // window.open(b, '_blank', 'location=yes,height=800,width=1200,scrollbars=yes,status=yes');
  }
}
